import invoices from "./invoices";

export const INVOICE_NAMESPACE = "invoices";

export default invoices;
